// src/components/SupportCTA.tsx
import { Box, Container, Typography, Button, Stack, Paper } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

export const SupportCTA = () => (
  <Box sx={{ py: 10, bgcolor: "primary.main", color: "white" }}>
    <Container maxWidth="md">
      <Paper
        elevation={0}
        sx={{
          p: 6,
          bgcolor: "rgba(255, 255, 255, 0.05)",
          borderRadius: 4,
          textAlign: "center",
          border: "1px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        <Stack spacing={3} alignItems="center">
          <CloudUploadIcon sx={{ fontSize: 60, color: "secondary.main" }} />
          <Typography variant="h4" fontWeight={800}>
            Ready for Cloud Migration?
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.8, fontSize: "1.1rem" }}>
            We provide seamless live migration of applications into cloud servers and 24/7 support services to ensure
            your enterprise never sleeps.
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mt: 2 }}>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              startIcon={<SupportAgentIcon />}
              sx={{ px: 4, py: 1.5, fontWeight: "bold" }}
            >
              Get 24/7 Support
            </Button>
            <Button variant="outlined" size="large" sx={{ color: "white", borderColor: "white", px: 4 }}>
              Learn More
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Container>
  </Box>
);
